import { render, staticRenderFns } from "./ModalTutoAction.vue?vue&type=template&id=31239934&scoped=true&"
import script from "./ModalTutoAction.vue?vue&type=script&lang=js&"
export * from "./ModalTutoAction.vue?vue&type=script&lang=js&"
import style0 from "./ModalTutoAction.vue?vue&type=style&index=0&id=31239934&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31239934",
  null
  
)

export default component.exports